import {isAnyOf} from '@reduxjs/toolkit'

import {first} from '@shared/helpers/array'

import {applyAddress} from '@web/actions/deliveryManager'
import {initDetailByAPI} from '@web/actions/detail'
import {DELIVERY_MEMO, EntryMethod} from '@web/core/constants'
import {decodeHtmlEntities as decode} from '@web/helpers/htmlEntities'
import {getInitialBaseAddressInfo, MemoInfo, OldMemoInfo} from '@web/slices/deliveryInfo/slice'
import makeSlice from '@web/slices/deliveryInfo/sliceMaker'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initDetailByAPI.fulfilled, (state, {payload}) => {
            const {deliveryAddress, order} = payload.data

            /** 상세 > 배송지영역 노출여부 */
            state.enabled =
                deliveryAddress.exposureDeliveryAddress &&
                !(order.saleChannelType === 'FLEAMARKET' && deliveryAddress.deliveryNothing)
            state.selected.addressInfo = {
                ...getInitialBaseAddressInfo(),
                receiverName: decode(deliveryAddress.receiverName),
                zipCode: deliveryAddress.zipCode ?? '',
                telNo1: deliveryAddress.receiverTelNo1 ?? '',
                telNo2: deliveryAddress.receiverTelNo2 ?? '',
                baseAddress: decode(deliveryAddress.baseAddress) ?? '',
                detailAddress: decode(deliveryAddress.detailAddress) ?? '',
                addressName: decode(deliveryAddress.addressName) ?? '',
            }
            state.deliveryNothingOrder = deliveryAddress.deliveryNothing
            /** 배송지 변경 가능 여부 */
            state.isDeliveryChangeable = deliveryAddress.deliveryAddressChangeable
            /** 도착보장 상품주문 포함 여부 */
            state.hasArrivalGuaranteeProduct = deliveryAddress.arrivalGuaranteeIncluded
            state.virtualPhoneNumber.restrictedVirtualPhoneNumbers = [deliveryAddress.virtualPhoneNumber ?? '']
            /** 메모관련 정보 */
            state.memo.individuallyInput = {
                type: first(deliveryAddress.deliveryMemos) ? DELIVERY_MEMO.WRITTEN : DELIVERY_MEMO.NOTHING,
                value: decode(first(deliveryAddress.deliveryMemos)?.deliveryMemo) ?? '',
            }
            state.memo.isParticularInput = deliveryAddress.deliveryMemoParticularInput ?? false
            state.memo.particularInputByItemId =
                deliveryAddress.deliveryMemos?.reduce<{[itemId: string]: OldMemoInfo}>(
                    (acc, {productName, deliveryMemo, optionContents}, index) => {
                        acc[index] = {
                            value: decode(deliveryMemo) ?? '',
                            type: DELIVERY_MEMO.WRITTEN,
                            options: optionContents,
                            originProductName: productName,
                        }
                        return acc
                    },
                    {},
                ) ?? {}
            /** 수령위치 */
            state.pickup.orderClosed = order.orderClosed
            state.pickup.location.type = deliveryAddress.pickupLocationType ?? null
            state.pickup.location.content = decode(deliveryAddress.pickupLocationContent ?? '')
            state.pickup.entryMethod.type = deliveryAddress.entryMethodType ?? EntryMethod.LOBBY_PW
            state.pickup.entryMethod.content = decode(deliveryAddress.entryMethodContent ?? '')
        })
        builder.addMatcher(isAnyOf(applyAddress.fulfilled), (state, {payload}) => {
            if (payload) {
                const {type, content} = payload || {}
                if (type === 'deliveryInfo') {
                    state.selected.addressInfo = content.deliveryAddress
                    state.memo.isParticularInput = content.isParticularInput
                    state.memo.particularInputByItemId = content.memos.reduce<{[itemId: string]: MemoInfo}>(
                        (acc, payloadMemo) => {
                            const originalMemo = state.memo.particularInputByItemId[payloadMemo.productOrderNo]

                            return {
                                ...acc,
                                [payloadMemo.productOrderNo]: {...originalMemo, value: payloadMemo.memo},
                            }
                        },
                        {},
                    )
                }
            }
        })
    },
})

export default slice.reducer
